import { sectionWiseChartReportData } from './sectionWiseChartData'

export const findthePercentage = async (data: any) => {
  const ChangeFormat = async (data: any) => {
    try {
      const bloomLevelMap: any = new Map()
      data.forEach((item: any) => {
        item.details.bloomlevel.forEach((bloom: any) => {
          if (bloomLevelMap.has(bloom?.name)) {
            const existingBloom = bloomLevelMap.get(bloom.name)
            existingBloom.totalMark += bloom.markTotal
            existingBloom.totalMarkObtained += bloom.markScored
          } else {
            bloomLevelMap.set(bloom.name, { sectionName: bloom.name, totalMark: bloom.markTotal, totalMarkObtained: bloom.markScored })
          }
        })
      })
      const consolidatedBloomlevel = [...bloomLevelMap.values()]
      return consolidatedBloomlevel
    } catch (err) {
      console.log(err)
    }
  }

  const newData = await ChangeFormat(data)
  const response = await sectionWiseChartReportData(newData)
  return response
}
